import customizationSlice, { CUSTOMIZATION_KEY_IN_STORE } from "./slice";
import { Reducer } from "@reduxjs/toolkit";
import { customSaga } from "./sagas";

export class CustomizationModule {
  getRootKeyInStore(): string {
    return CUSTOMIZATION_KEY_IN_STORE;
  }

  getReducers(): Reducer {
    return customizationSlice.reducer;
  }

  getSagas(): any {
    return customSaga;
  }
}

export const moduleInstance = new CustomizationModule();
